class Feeder{

    constructor(){
    }

    async updateOfflineEpg(urls = [], updateProgressMessageType){}
}

export default Feeder;



// WEBPACK FOOTER //
// ./src/AAFPersistenceManager/feeders/Feeder.js